// Fronted/src/contexts/updatesContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import UpdateService from '../services/updateService';
const UpdatesContext = createContext();

export const useUpdates = () => {
  return useContext(UpdatesContext);
};

export const UpdatesProvider = ({ children }) => {
  const [updates, setUpdates] = useState([]);
  const [currentUpdate, setCurrentUpdate] = useState({
    id: null,
    video_src: null,
    thumbnail: null,
    title: "Loading...",
    category: "Sermon"
  }); // Safe defaults
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        setLoading(true);
        const response = await UpdateService.getAllUpdates();
        
        if (!response || response.length === 0) {
          throw new Error('No updates found');
        }
        
        setUpdates(response);
        setCurrentUpdate(response[0] || {
          id: null,
          video_src: null,
          thumbnail: null,
          title: "No sermon available",
          category: "Sermon"
        });
        setError(null);
      } catch (err) {
        console.error('Error fetching updates:', err);
        setError(err.message);
        setCurrentUpdate({
          id: null,
          video_src: null,
          thumbnail: null,
          title: "Error loading content",
          category: "Sermon"
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUpdates();
  }, []);

  const value = {
    updates,
    currentUpdate,
    loading,
    error,
    setUpdates,
    setCurrentUpdate
  };
  return (
    <UpdatesContext.Provider value={value}>
      {children}
    </UpdatesContext.Provider>
  );
};

export default UpdatesContext; 